import styled from "styled-components";
import AllDeviceOverallTable from "../../molecules/all/AllDeviceOverallTable";
import { COLORS } from "../../../constants/colors";
import AllDeviceSelectBox from "../../molecules/all/AllDeviceSelectBox";
import PublicPaging from "../../publics/PublicPaging";
import { AllDeviceOverallCardProps } from "../../../constants/types";

const AllDeviceOverallCard = (props: AllDeviceOverallCardProps) => {
  return (
    <Container>
      <AllDeviceSelectBox
        categories={props.categories}
        option={props.option}
        render={props.render}
      />
      <AllDeviceOverallTable data={props.data.all} page={props.page} />
      <PublicPaging dataLength={props.data.all.length} page={props.page} />
    </Container>
  );
};

export default AllDeviceOverallCard;

const Container = styled.div`
  width: 69%;
  height: 100%;
  border: 0.2vw solid ${COLORS.lightGray};
  box-sizing: border-box;
  padding: 1%;

  display: flex;
  flex-wrap: wrap;
  align-content: space-between;
`;
